angular.module('ihestiaCommonDirectives')
  .constant('ihestiaDictionaryEmptyStringCodeReplace', '_empty_string_value_replace_for_select');